// src/components/InventarioDashboard.js
import React, { useEffect, useState } from 'react';
import { useApi } from '../api';

import { formatearPrecio, formatearFechaLocal } from './utils';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import DownloadIcon from '@mui/icons-material/Download';
import { motion } from 'framer-motion';
import {
  Alert, Box, Button, Card, Container, Dialog, DialogActions, DialogContent,
  DialogTitle, Divider, Grid, Snackbar, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, useMediaQuery, useTheme,
} from '@mui/material';



const InventarioDashboard = () => {
  const [productos, setProductos] = useState([]);
  const [resumen, setResumen] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [ventaModal, setVentaModal] = useState({ show: false, producto: null });
const [editarModal, setEditarModal] = useState({ show: false, producto: null });

const [guardandoVenta, setGuardandoVenta] = useState(false);
const [descargando, setDescargando] = useState(false);
const [toastMsg, setToastMsg] = useState('');
const [showToast, setShowToast] = useState(false);
const api = useApi();
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [nuevoProducto, setNuevoProducto] = useState({
    nombre: '',
    descripcion: '',
    cantidad: 0,
    precio_costo: 0,
    precio_cliente: 0,
    stock_minimo: 2
  });
  const [cantidadesEditadas, setCantidadesEditadas] = useState({});
  const [productoEditado, setProductoEditado] = useState({ nombre: '', descripcion: '' });


  useEffect(() => {
    fetchProductos();
    fetchResumen();
  }, []);

const fetchProductos = async () => {
  const res = await api.get(
    `${process.env.REACT_APP_API_URL}/api/inventario/productos/`
  );
  setProductos(res.data);
};

const fetchResumen = async () => {
  const res = await api.get(
    `${process.env.REACT_APP_API_URL}/api/inventario/resumen/`
  );
  setResumen(res.data);
};
  const camposEnteros = ['cantidad', 'precio_costo', 'precio_cliente', 'stock_minimo'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (camposEnteros.includes(name) && !/^\d*$/.test(value)) return;
    setNuevoProducto({ ...nuevoProducto, [name]: value });
  };

  const handleCantidadChange = (id, nuevaCantidad) => {
    setCantidadesEditadas(prev => ({ ...prev, [id]: nuevaCantidad }));
  };

const guardarCantidad = async (producto) => {
  const nuevaCantidad = cantidadesEditadas[producto.id];
  if (nuevaCantidad < producto.cantidad) {
    setVentaModal({ show: true, producto });
  } else {
    await api.patch(
      `${process.env.REACT_APP_API_URL}/api/inventario/productos/${producto.id}/`,
      { cantidad: nuevaCantidad }
    );
    fetchProductos();
    fetchResumen();
  }
};


const confirmarVenta = async () => {
  const producto = ventaModal.producto;
  const nuevaCantidad = cantidadesEditadas[producto.id];
  const cantidadVendida = producto.cantidad - nuevaCantidad;

  setGuardandoVenta(true);
  try {
    await api.patch(
      `${process.env.REACT_APP_API_URL}/api/inventario/productos/${producto.id}/`,
      { cantidad: nuevaCantidad }
    );

    const ingreso = {
      descripcion: `Venta de ${producto.nombre}`,
      tipo: 'Ingreso',
      monto: (parseFloat(producto.precio_cliente) * cantidadVendida).toFixed(2),
      fecha: formatearFechaLocal()
    };

    await api.post(
      `${process.env.REACT_APP_API_URL}/api/ingresos-gastos/`,
      ingreso
    );

    setToastMsg('Inventario actualizado y venta registrada');
    setShowToast(true);
  } catch (error) {
    console.error('Error al confirmar venta:', error);
    alert('Ocurrió un error al registrar la venta.');
  } finally {
    setGuardandoVenta(false);
    setVentaModal({ show: false, producto: null });
    fetchProductos();
    fetchResumen();
  }
};



    const abrirModalEditar = (producto) => {
            setProductoEditado({
                ...producto,
                precio_costo: Math.floor(producto.precio_costo),
                precio_cliente: Math.floor(producto.precio_cliente),
            });
            setEditarModal({ show: true, producto });
            };
  const handleEditarChange = (e) => {
    const { name, value } = e.target;
    if (camposEnteros.includes(name) && !/^\d*$/.test(value)) return;
    setProductoEditado(prev => ({ ...prev, [name]: value }));
  };

const guardarEdicion = async () => {
  await api.patch(
    `${process.env.REACT_APP_API_URL}/api/inventario/productos/${editarModal.producto.id}/`,
    productoEditado
  );
  setEditarModal({ show: false, producto: null });
  fetchProductos();
};
const handleSubmit = async (e) => {
  e.preventDefault();
  await api.post(
    `${process.env.REACT_APP_API_URL}/api/inventario/productos/`,
    nuevoProducto
  );
  setShowModal(false);
  setNuevoProducto({ nombre: '', descripcion: '', cantidad: 0, precio_costo: 0, precio_cliente: 0, stock_minimo: 2 });
  fetchProductos();
  fetchResumen();
};

const descargarExcel = async () => {
  setDescargando(true);
  try {
    const response = await api.get(
      `${process.env.REACT_APP_API_URL}/api/inventario/exportar/`,
      { responseType: 'blob' }
    );
    const blobUrl = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    const fecha = formatearFechaLocal();
    link.href = blobUrl;
    link.download = `inventario_${fecha}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Error al descargar el inventario:', error);
    alert('No se pudo descargar el inventario.');
  } finally {
    setDescargando(false);
  }
};

const eliminarProducto = async (id) => {
  if (!window.confirm('¿Estás seguro de que deseas eliminar este producto?')) return;
  try {
    await api.delete(
      `${process.env.REACT_APP_API_URL}/api/inventario/productos/${id}/`
    );
    setProductos(productos.filter(p => p.id !== id));
  } catch (error) {
    console.error('Error eliminando producto:', error);
    alert('No se pudo eliminar el producto.');
  }
};


  return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <motion.h2
          className="titulo-app sin-subrayado"
          style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 0 }}
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.7, 0.2, 0.1, 0.98] }}
        >
          <Inventory2OutlinedIcon sx={{ fontSize: 36, color: '#083a94' }} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span>Dashboard de Inventario</span>
            {/* Línea animada */}
            <motion.span
              style={{
                display: 'block',
                width: 60,
                height: 4,
                marginTop: 6,
                background: 'linear-gradient(90deg, #083a94 80%, #21a1ff 100%)',
                borderRadius: 2,
                originX: 0
              }}
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.8, delay: 0.3, ease: [0.8, 0, 0.3, 1] }}
            />
          </div>
        </motion.h2>




      {resumen && (
        <Grid container spacing={2} sx={{ textAlign: 'center', mb: 4 }}>
          <Grid item xs={6} sm={4} md={2.4}>
            <div className="card inventario-card">
              <div className="card-body">
                <h5>Total Productos</h5>
                <p>{resumen.total_productos}</p>
              </div>
            </div>
          </Grid>

          <Grid item xs={6} sm={4} md={2.4}>
            <div className="card inventario-card">
              <div className="card-body">
                <h5>Total Ítems</h5>
                <p>{resumen.total_items}</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <div className="card inventario-card">
              <div className="card-body">
                <h5>Valor Real</h5>
                <p>${formatearPrecio(resumen.valor_real)}</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <div className="card inventario-card">
              <div className="card-body">
                <h5>Valor Cliente</h5>
                <p>${formatearPrecio(resumen.valor_venta)}</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <div className="card inventario-card stock-bajo">
              <div className="card-body">
                <h5>Bajo Stock</h5>
                <p>{resumen.bajo_stock}</p>
              </div>
            </div>
          </Grid>
        </Grid>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, flexWrap: 'wrap', gap: 1 }}>
        <motion.h4
          className="titulo-app"
          style={{ marginTop: 38, marginBottom: 18 }}
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.7, 0.2, 0.1, 0.98] }}
        >
          Lista de Productos
        </motion.h4>

        <Box sx={{ display: 'flex', gap: 1 }}>
          <motion.div
              whileHover={{ scale: 1.06, boxShadow: "0 4px 20px #1976d244" }}
              transition={{ type: "spring", stiffness: 400, damping: 15 }}
              style={{ display: 'inline-block' }}
            >
              <Button
                variant="outlined"
                onClick={descargarExcel}
                disabled={descargando}
              >
                <DownloadIcon sx={{ fontSize: 20, verticalAlign: 'text-bottom', mr: 1 }} />
                {descargando ? 'Descargando...' : 'Descargar Excel'}
              </Button>
            </motion.div>
          <motion.div
              whileHover={{ scale: 1.06, boxShadow: "0 4px 20px #1976d244" }}
              transition={{ type: "spring", stiffness: 400, damping: 15 }}
              style={{ display: 'inline-block' }}
            >
              <Button variant="contained" className="btn-app" onClick={() => setShowModal(true)}>
                Agregar Producto
              </Button>
            </motion.div>
        </Box>
      </Box>

      {isMobile ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {productos.map(prod => (
            <Card
              key={prod.id}
              variant="outlined"
              sx={{ p: 2, bgcolor: prod.cantidad < prod.stock_minimo ? '#f8d7da' : 'background.paper' }}
            >
              <Typography sx={{ fontWeight: 700 }}>{prod.nombre}</Typography>
              {prod.descripcion && (
                <Typography variant="body2" color="text.secondary">
                  {prod.descripcion}
                </Typography>
              )}

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                <Typography variant="body2">Costo: ${formatearPrecio(prod.precio_costo)}</Typography>
                <Typography variant="body2">Cliente: ${formatearPrecio(prod.precio_cliente)}</Typography>
              </Box>

              <Divider sx={{ my: 1.5 }} />

              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1.5 }}>
                <Button variant="outlined" color="inherit" size="small" onClick={() => handleCantidadChange(prod.id, (cantidadesEditadas[prod.id] ?? prod.cantidad) + 1)}>+</Button>
                <Box component="span" sx={{ mx: 2, fontWeight: 600 }}>{cantidadesEditadas[prod.id] ?? prod.cantidad}</Box>
                <Button
                  variant="outlined"
                  color="inherit"
                  size="small"
                  onClick={() => handleCantidadChange(prod.id, (cantidadesEditadas[prod.id] ?? prod.cantidad) - 1)}
                  disabled={(cantidadesEditadas[prod.id] ?? prod.cantidad) <= 0}
                >
                  -
                </Button>
              </Box>

              <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Button variant="contained" color="success" size="small" onClick={() => guardarCantidad(prod)} disabled={cantidadesEditadas[prod.id] === undefined || cantidadesEditadas[prod.id] === prod.cantidad}>Guardar</Button>
                <Button variant="contained" color="warning" size="small" onClick={() => abrirModalEditar(prod)}>Editar</Button>
                <Button
                  variant="contained"
                  color={prod.cantidad === 0 ? "error" : "inherit"}
                  size="small"
                  onClick={() => eliminarProducto(prod.id)}
                  disabled={prod.cantidad > 0}
                >
                  Eliminar
                </Button>
              </Box>
            </Card>
          ))}
        </Box>
      ) : (
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table className="table-inventario">
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell>Descripción</TableCell>
                <TableCell>Cantidad</TableCell>
                <TableCell>Precio Costo</TableCell>
                <TableCell>Precio Cliente</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productos.map(prod => (
                <TableRow key={prod.id} sx={prod.cantidad < prod.stock_minimo ? { bgcolor: '#f8d7da' } : undefined}>
                  <TableCell>{prod.nombre}</TableCell>
                  <TableCell>{prod.descripcion}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Button variant="outlined" color="inherit" size="small" onClick={() => handleCantidadChange(prod.id, (cantidadesEditadas[prod.id] ?? prod.cantidad) + 1)}>+</Button>
                      <Box component="span" sx={{ mx: 2 }}>{cantidadesEditadas[prod.id] ?? prod.cantidad}</Box>
                      <Button
                        variant="outlined"
                        color="inherit"
                        size="small"
                        onClick={() => handleCantidadChange(prod.id, (cantidadesEditadas[prod.id] ?? prod.cantidad) - 1)}
                        disabled={(cantidadesEditadas[prod.id] ?? prod.cantidad) <= 0}
                        >
                        -
                        </Button>
                    </Box>
                  </TableCell>
                    <TableCell>${formatearPrecio(prod.precio_costo)}</TableCell>
                    <TableCell>${formatearPrecio(prod.precio_cliente)}</TableCell>

                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                      <Button variant="contained" color="success" size="small" onClick={() => guardarCantidad(prod)} disabled={cantidadesEditadas[prod.id] === undefined || cantidadesEditadas[prod.id] === prod.cantidad}>Guardar</Button>
                      <Button variant="contained" color="warning" size="small" onClick={() => abrirModalEditar(prod)}>Editar</Button>
                      <Button
                      variant="contained"
                      color={prod.cantidad === 0 ? "error" : "inherit"}
                      size="small"
                      onClick={() => eliminarProducto(prod.id)}
                      disabled={prod.cantidad > 0}
                      >
                      Eliminar
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Dialog open={showModal} onClose={() => setShowModal(false)} fullWidth maxWidth="xs" slotProps={{ paper: { className: 'modal-inventario-app' } }}>
        <DialogTitle>Agregar Producto</DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField label="Nombre" name="nombre" value={nuevoProducto.nombre} onChange={handleChange} required fullWidth />
            <TextField label="Descripción" name="descripcion" value={nuevoProducto.descripcion} onChange={handleChange} fullWidth />
            <TextField label="Cantidad" type="number" name="cantidad" value={nuevoProducto.cantidad} onChange={handleChange} required fullWidth />
            <TextField label="Precio Costo" inputMode="numeric" name="precio_costo" value={nuevoProducto.precio_costo} onChange={handleChange} required fullWidth />
            <TextField label="Precio Cliente" inputMode="numeric" name="precio_cliente" value={nuevoProducto.precio_cliente} onChange={handleChange} required fullWidth />
            <TextField label="Stock Mínimo" type="number" name="stock_minimo" value={nuevoProducto.stock_minimo} onChange={handleChange} fullWidth />
            <Button variant="contained" type="submit">Guardar</Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={ventaModal.show} onClose={() => setVentaModal({ show: false, producto: null })} slotProps={{ paper: { className: 'modal-inventario-app' } }}>
        <DialogTitle>¿Registrar venta?</DialogTitle>
        <DialogContent>
          <Typography>Se está reduciendo el inventario del producto <strong>{ventaModal.producto?.nombre}</strong>. ¿Desea registrar esta venta en el módulo de ingresos y egresos?</Typography>
        </DialogContent>
        <DialogActions>
          <Button
                    variant="outlined"
                    color="inherit"
                    onClick={async () => {
                      const producto = ventaModal.producto;
                      const nuevaCantidad = cantidadesEditadas[producto.id];

                      await api.patch(
                        `${process.env.REACT_APP_API_URL}/api/inventario/productos/${producto.id}/`,
                        { cantidad: nuevaCantidad }
                      );

                      setVentaModal({ show: false, producto: null });
                      fetchProductos();
                      fetchResumen();
                      setToastMsg('Inventario actualizado');
                      setShowToast(true);
                    }}
                  >
                    No
                  </Button>

          <Button variant="contained" disabled={guardandoVenta} onClick={confirmarVenta}>Sí</Button>
        </DialogActions>
      </Dialog>

{/* Modal Editar Producto */}
<Dialog open={editarModal.show} onClose={() => setEditarModal({ show: false, producto: null })} fullWidth maxWidth="xs" slotProps={{ paper: { className: 'modal-inventario-app' } }}>
  <DialogTitle>Editar Producto</DialogTitle>
  <DialogContent>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      <TextField
        label="Nombre"
        name="nombre"
        value={productoEditado.nombre}
        onChange={handleEditarChange}
        required
        fullWidth
      />

      <TextField
        label="Descripción"
        name="descripcion"
        value={productoEditado.descripcion}
        onChange={handleEditarChange}
        fullWidth
      />

      <TextField
        label="Precio Costo"
        inputMode="numeric"
        name="precio_costo"
        value={productoEditado.precio_costo}
        onChange={handleEditarChange}
        fullWidth
      />

      <TextField
        label="Precio Cliente"
        inputMode="numeric"
        name="precio_cliente"
        value={productoEditado.precio_cliente}
        onChange={handleEditarChange}
        fullWidth
      />
    </Box>
  </DialogContent>
  <DialogActions>
    <Button variant="outlined" color="inherit" onClick={() => setEditarModal({ show: false, producto: null })}>
      Cancelar
    </Button>
    <Button variant="contained" onClick={guardarEdicion}>
      Guardar
    </Button>
  </DialogActions>
</Dialog>
        <Snackbar
          open={showToast}
          onClose={() => setShowToast(false)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert severity="success" onClose={() => setShowToast(false)} sx={{ bgcolor: 'success.main', color: '#fff' }}>
            {toastMsg}
          </Alert>
        </Snackbar>

    </Container>
  );
};

export default InventarioDashboard;
